<template>
  <div class="dt-details">
    <div class="dt-details--header"> {{$t('promoter_details')}} </div>
    <div class="dt-details--body">
      <!-- <div class="dt-details--col">
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('date')}} </div>
            <div class="dt-details--value">{{selectedBooking.start_date}} </div>
          </div>
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('end_date')}} </div>
            <div class="dt-details--value"> {{selectedBooking.end_date}} </div>
          </div>
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('date_name')}} </div>
            <div class="dt-details--value"> {{selectedBooking.booking_status_name}} </div>
          </div>
        </div>
        <div class="dt-details--col">
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('venue')}} </div>
            <div class="dt-details--value"> {{selectedBooking.booking_location_name}} </div>
          </div>
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('city')}} </div>
            <div class="dt-details--value"> {{selectedBooking.city}} </div>
          </div>
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('country')}} </div>
            <div class="dt-details--value"> {{selectedBooking.country}} </div>
          </div>
        </div>
        <div class="dt-details--col">
          <div class="dt-details--row">
            <div class="dt-details--label">{{$t('promoter')}} </div>
            <div class="dt-details--value"> {{selectedBooking.promoter_contact}} </div>
          </div>
          <div class="dt-details--row">
            <div class="dt-details--label">{{$t('contacts')}}</div>
            <div class="dt-details--value"> {{selectedBooking.contact_email1}} </div>
          </div>
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('currency')}} </div>
            <div class="dt-details--value">19062018</div>
          </div>
        </div>
        <div class="dt-details--col">
          <div class="dt-details--row">
            <div class="dt-details--label"> {{$t('staff')}} </div>
            <div class="dt-details--value"> {{selectedBooking.user_name}} </div>
          </div>
          <div class="dt-details--row">
            <div class="dt-details--label">Calendar Date Id</div>
            <div class="dt-details--value"> {{selectedBooking.calendar_date_id}} </div>
          </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../../../store";
import { mapActions, mapGetters } from "vuex";
import * as ActionTypes from "../../../store/types";

export default {
  computed: {
    ...mapGetters(storeNS, {
      selectedBooking: "selectedBooking"
    })
  }
};
</script>

<style>
</style>
